var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 123,
    viewBox: "0 0 200 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.7476 43.3213H0V63.1163L19.7548 82.89H108.481V63.095L88.7476 43.3213Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.503 82.89H19.7549V102.685H108.503V82.89Z",
    fill: "#60A5FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.503 82.89H19.7549V102.685H108.503V82.89Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.503 102.664H19.7549V122.459H108.503V102.664Z",
    fill: "#60A5FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.503 102.664H19.7549V122.459H108.503V102.664Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.503 63.095H19.7549V82.89H108.503V63.095Z",
    fill: "#60A5FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9361 72.4643C45.9361 73.9312 44.7481 75.1177 43.2859 75.1177C41.8238 75.1177 40.6357 73.9312 40.6357 72.4643C40.6357 70.9974 41.8238 69.8174 43.2859 69.8174C44.7481 69.8174 45.9361 71.0039 45.9361 72.4643Z",
    fill: "#3B82F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9361 92.4879C45.9361 93.9547 44.7481 95.1413 43.2859 95.1413C41.8238 95.1413 40.6357 93.9547 40.6357 92.4879C40.6357 91.021 41.8238 89.8409 43.2859 89.8409C44.7481 89.8409 45.9361 91.0275 45.9361 92.4879Z",
    fill: "#60A5FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9361 112.511C45.9361 113.978 44.7481 115.165 43.2859 115.165C41.8238 115.165 40.6357 113.978 40.6357 112.511C40.6357 111.045 41.8238 109.865 43.2859 109.865C44.7481 109.865 45.9361 111.051 45.9361 112.511Z",
    fill: "#93C5FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1021 92.4879C37.1021 93.9547 35.9141 95.1413 34.4519 95.1413C32.9898 95.1413 31.8018 93.9547 31.8018 92.4879C31.8018 91.021 32.9898 89.8409 34.4519 89.8409C35.9141 89.8409 37.1021 91.0275 37.1021 92.4879Z",
    fill: "#60A5FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1021 72.4643C37.1021 73.9312 35.9141 75.1177 34.4519 75.1177C32.9898 75.1177 31.8018 73.9312 31.8018 72.4643C31.8018 70.9974 32.9898 69.8174 34.4519 69.8174C35.9141 69.8174 37.1021 71.0039 37.1021 72.4643Z",
    fill: "#3B82F6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2681 92.4879C28.2681 93.9547 27.0801 95.1413 25.618 95.1413C24.1558 95.1413 22.9678 93.9547 22.9678 92.4879C22.9678 91.021 24.1558 89.8409 25.618 89.8409C27.0801 89.8409 28.2681 91.0275 28.2681 92.4879Z",
    fill: "#60A5FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1021 112.511C37.1021 113.978 35.9141 115.165 34.4519 115.165C32.9898 115.165 31.8018 113.978 31.8018 112.511C31.8018 111.045 32.9898 109.865 34.4519 109.865C35.9141 109.865 37.1021 111.051 37.1021 112.511Z",
    fill: "#93C5FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2681 72.4643C28.2681 73.9312 27.0801 75.1177 25.618 75.1177C24.1558 75.1177 22.9678 73.9312 22.9678 72.4643C22.9678 70.9974 24.1558 69.8174 25.618 69.8174C27.0801 69.8174 28.2681 71.0039 28.2681 72.4643Z",
    fill: "#3B82F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2681 112.511C28.2681 113.978 27.0801 115.165 25.618 115.165C24.1558 115.165 22.9678 113.978 22.9678 112.511C22.9678 111.045 24.1558 109.865 25.618 109.865C27.0801 109.865 28.2681 111.051 28.2681 112.511Z",
    fill: "#93C5FD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.3213V63.1163L19.7548 82.89V63.095L0 43.3213Z",
    fill: "#93C5FD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.3213V63.1163L19.7548 82.89V63.095L0 43.3213Z",
    fill: "#93C5FD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 63.1163V82.9113L19.7548 102.685V82.89L0 63.1163Z",
    fill: "#93C5FD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 63.1163V82.9113L19.7548 102.685V82.89L0 63.1163Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 82.89V102.706L19.7548 122.459V102.664L0 82.89Z",
    fill: "#93C5FD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 82.89V102.706L19.7548 122.459V102.664L0 82.89Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.772 0H73.2641C71.4823 0 70.0361 1.44619 70.0361 3.22798V88.6398C70.0361 90.4216 71.4823 91.8678 73.2641 91.8678H196.772C198.554 91.8678 200 90.4216 200 88.6398V3.23144C200 1.44965 198.554 0.00345921 196.772 0.00345921V0Z",
    fill: "#172554"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M152.839 85.1523L146.726 117.65H117.162L122.334 85.1523H152.839Z",
    fill: "#BFDBFE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M170.564 122.639L98.6873 122.639V119.249C98.6873 117.654 99.9813 116.36 101.576 116.36L167.672 116.36C169.267 116.36 170.561 117.654 170.561 119.249V122.639H170.564Z",
    fill: "#BFDBFE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.611 91.8712L150.957 95.3241C150.957 95.3241 140.391 94.8847 136.056 101.403C131.292 108.568 118.328 109.305 118.328 109.305L121.124 91.8712H151.611Z",
    fill: "#93C5FD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.772 0H73.2641C71.4823 0 70.0361 1.44619 70.0361 3.22798V88.6398C70.0361 90.4216 71.4823 91.8678 73.2641 91.8678H196.772C198.554 91.8678 200 90.4216 200 88.6398V3.23144C200 1.44965 198.554 0.00345921 196.772 0.00345921V0Z",
    fill: "#BFDBFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.936 4.2196H75.9434V83.5481H194.936V4.2196Z",
    fill: "#93C5FD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2906 8.01572C90.2906 8.71639 89.7231 9.28316 89.0247 9.28316C88.3263 9.28316 87.7588 8.71639 87.7588 8.01572C87.7588 7.31505 88.3263 6.7514 89.0247 6.7514C89.7231 6.7514 90.2906 7.31816 90.2906 8.01572Z",
    fill: "#60A5FA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0708 8.01572C86.0708 8.71639 85.5034 9.28316 84.8049 9.28316C84.1065 9.28316 83.5391 8.71639 83.5391 8.01572C83.5391 7.31505 84.1065 6.7514 84.8049 6.7514C85.5034 6.7514 86.0708 7.31816 86.0708 8.01572Z",
    fill: "#60A5FA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8511 8.01572C81.8511 8.71639 81.2836 9.28316 80.5852 9.28316C79.8868 9.28316 79.3193 8.71639 79.3193 8.01572C79.3193 7.31505 79.8868 6.7514 80.5852 6.7514C81.2836 6.7514 81.8511 7.31816 81.8511 8.01572Z",
    fill: "#60A5FA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.642 20.2929C141.796 20.6077 142.477 21.7985 142.162 22.9526L129.166 70.6061C128.851 71.7602 127.66 72.4407 126.506 72.1259C125.352 71.8111 124.671 70.6203 124.986 69.4662L137.982 21.8128C138.297 20.6586 139.488 19.9782 140.642 20.2929ZM147.205 29.5153C148.051 28.6694 149.422 28.6694 150.268 29.5153L165.431 44.6778C166.276 45.5237 166.276 46.8952 165.431 47.7411L150.268 62.9035C149.422 63.7494 148.051 63.7494 147.205 62.9035C146.359 62.0576 146.359 60.6861 147.205 59.8402L160.836 46.2094L147.205 32.5786C146.359 31.7327 146.359 30.3612 147.205 29.5153ZM119.943 29.5153C120.789 30.3612 120.789 31.7327 119.943 32.5786L106.312 46.2094L119.943 59.8402C120.789 60.6861 120.789 62.0576 119.943 62.9035C119.097 63.7494 117.726 63.7494 116.88 62.9035L101.717 47.7411C100.872 46.8952 100.872 45.5237 101.717 44.6778L116.88 29.5153C117.726 28.6694 119.097 28.6694 119.943 29.5153Z",
    fill: "#60A5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdk);
export default __webpack_public_path__ + "static/media/sdk.7494aba64a375cd391cb911cfac75649.svg";
export { ForwardRef as ReactComponent };